import React from 'react';
export function MissionSection() {
  return <section id="mission" className="py-20 md:py-28 bg-white" data-id="element-349">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-350">
        <div className="mb-12" data-id="element-351">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-352">
            Наша Місія
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-353" />
        </div>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-354">
          <p data-id="element-355">
            Ми створюємо чесну освіту — щоб знання формували відповідальність.
          </p>

          <p data-id="element-356">
            Ми розвиваємо незалежні дослідження — щоб рішення ґрунтувалися на
            фактах, а не на припущеннях.
          </p>

          <p data-id="element-357">
            Ми формуємо усвідомлення — щоб про ризики говорили відкрито і без
            стигми.
          </p>

          <p data-id="element-358">
            Ми будуємо відкритий діалог — між гравцем, бізнесом, експертами та
            суспільством та державою.
          </p>

          <p data-id="element-359">Ми надаємо відповідальну підтримку — тим, хто її потребує.</p>

          <p data-id="element-360">
            Ми працюємо заради прозорих результатів — для розвитку чесного та
            відповідального азарту в Україні.
          </p>

          <div className="pt-4 space-y-2" data-id="element-361">
            <p className="text-[#0A5E5C] font-serif font-semibold text-xl" data-id="element-362">
              Це простір довіри.
            </p>
            <p className="text-[#0A5E5C] font-serif font-semibold text-xl" data-id="element-363">
              Це простір відповідальності.
            </p>
            <p className="text-[#0A5E5C] font-serif font-bold text-2xl" data-id="element-364">
              Це ПРОСТІР ЧЕСНОЇ ГРИ.
            </p>
          </div>
        </div>
      </div>
    </section>;
}